import { gql } from '@apollo/client'

export default {
  cameraOperator: gql`
    query cameraOperator($cisId: String, $cameraOperatorId: String) {
      cameraOperator(cisId: $cisId, cameraOperatorId: $cameraOperatorId) {
        id
        inProgressProjects {
          id
          status
          actualImagesCaptured
          languages
          title
        }
      }
    }
  `,
  getGroup: gql`
    query getGroup($groupIdOrArkId: String!) {
      group(groupIdOrArkId: $groupIdOrArkId) {
        imageApids
      }
    }
  `,
  projectCard: gql`
    query projectCard(
      $projectId: String!
      $cameraOperatorId: String!
      $weekEndings: [String]
      $initialRequest: Boolean!
      $initialResultsCount: Int
    ) {
      projectDashboard(
        projectId: $projectId
        cameraOperatorId: $cameraOperatorId
        weekEndings: $weekEndings
        initialResultsCount: $initialResultsCount
      ) {
        camera @include(if: $initialRequest)
        place @include(if: $initialRequest)
        estimatedImages @include(if: $initialRequest)
        totalCount @include(if: $initialRequest)
        weeks {
          weekEnding
          status
          hadRework
          folderCount
        }
        weekEndingsWithFolders {
          weekending
          count
        }
        needsRework @include(if: $initialRequest) {
          id
          properties {
            name
            values
          }
          workflowActions {
            name
            status
            userId
            date {
              fromTimestamp
            }
            parameters {
              name
              value
            }
          }
        }
      }
    }
  `,

  weekPage: gql`
    query weekPage(
      $projectId: String!
      $cameraOperatorId: String!
      $weekEndings: [String]!
      $initialRequest: Boolean!
      $offset: Int
      $getEverything: Boolean
    ) {
      projectDashboard(
        projectId: $projectId
        cameraOperatorId: $cameraOperatorId
        weekEndings: $weekEndings
        pageSize: 200
        offset: $offset
        getEverything: $getEverything
      ) {
        camera @include(if: $initialRequest)
        place @include(if: $initialRequest)
        totalCount @include(if: $initialRequest)
        needsRework @include(if: $initialRequest) {
          id
          properties(names: ["auditResults", "directory", "clickTotal", "imageCount", "rework", "dufi"]) {
            name
            values
          }
          workflowActions {
            name
            status
            userId
            date {
              fromTimestamp
            }
            parameters {
              name
              value
            }
          }
        }
        folders {
          id
          childCount
          languages
          imageGroupNumber
          properties(
            names: ["auditResults", "directory", "clickTotal", "imageCount", "rework", "auditFeedback", "dufi"]
          ) {
            name
            values
          }
          workflowActions {
            name
            status
            userId
            date {
              fromTimestamp
            }
            parameters {
              name
              value
            }
          }
        }
      }
    }
  `,
  projectDashboardProject: gql`
    query projectDashboardProject(
      $cameraOperatorId: String!
      $projectId: String!
      $weekEnding: String!
      $pageSize: Int
      $nextPageToken: String
    ) {
      projectDashboardProject(
        cameraOperatorId: $cameraOperatorId
        projectId: $projectId
        weekEnding: $weekEnding
        pageSize: $pageSize
        nextPageToken: $nextPageToken
      ) {
        folders {
          id
          childCount
          languages
          imageGroupNumber
          properties(
            names: ["auditResults", "directory", "clickTotal", "imageCount", "rework", "auditFeedback", "dufi"]
          ) {
            name
            values
          }
          workflowActions {
            name
            status
            userId
            date {
              fromTimestamp
            }
            parameters {
              name
              value
            }
          }
        }
        totalCount
        numberReturned
        nextPageToken
      }
    }
  `,
  imageQualityTags: gql`
    query imageQualityTags($parentIds: [ID]!) {
      imageQualityTags(parentIds: $parentIds) {
        id
        name
        parentIds
        properties {
          name
          values
        }
      }
    }
  `,
  getAuditor: gql`
    query getAuditor($id: ID!) {
      getUser(id: $id) {
        contactName
      }
    }
  `,
  recordTypes: gql`
    query recordTypes {
      recordTypes {
        id
        name
      }
    }
  `,
  changeLogs: gql`
    query changeLogs($id: String!) {
      changeLogs(groupId: $id) {
        logs {
          rawData
          eventName
        }
      }
    }
  `,
  standardsLanguages: gql`
    query StandardsLanguages($langOverride: String) {
      standardsLanguages(langOverride: $langOverride) {
        code
        language
      }
    }
  `,
  places: gql`
    query places($placeIds: [ID!]) {
      places(placeIds: $placeIds) {
        id
        fullName
      }
    }
  `,
}
